import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Chatbot, LoadingState } from './components';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load components for better performance
const LandingPage = React.lazy(() => import('./Docs/LandingPage'));
const BlogList = React.lazy(() => import('./components/BlogList'));
const BlogPost = React.lazy(() => import('./components/BlogPost'));
const CaseStudies = React.lazy(() => import('./pages/CaseStudies'));
const Services = React.lazy(() => import('./pages/Services'));
const ContactForm = React.lazy(() => import('./pages/ContactForm'));
const AboutUs = React.lazy(() => import('./pages/AboutUs'));
const CareersPage = React.lazy(() => import('./pages/CareersPage'));
const PressPage = React.lazy(() => import('./pages/PressPage'));
const Privacy = React.lazy(() => import('./components/PolicyComponents/Privacy.jsx'));
const CookiePolicy = React.lazy(() => import('./components/PolicyComponents/CookiePolicy.jsx'));
const TermsOfService = React.lazy(() => import('./components/PolicyComponents/TermsOfService.jsx'));

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen transition-colors duration-200 bg-white dark:bg-transparent text-gray-900 dark:text-white">
          <ErrorBoundary>
            <Suspense fallback={<LoadingState />}>
              <Routes>
                {/* Main Routes */}
                <Route path="/" element={<LandingPage />} />
                
                {/* Blog Routes */}
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                
                {/* Other Routes */}
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<ContactForm />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/press" element={<PressPage />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cookies" element={<CookiePolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="*" element={<LandingPage />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
          <Chatbot />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
